import { render } from "./EditAddedItem.vue?vue&type=template&id=1e7d68b2"
import script from "./EditAddedItem.vue?vue&type=script&lang=js"
export * from "./EditAddedItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__